import React, {useCallback, useMemo} from 'react';
import {useDispatch} from 'react-redux';

import {getPaginatedRowNumber} from 'src/components/main-column';

import {EllipsisTextHint} from '@pb/kit-component-ellipsis-text-hint';
import {Icons} from '@pb/kit-component-icon';
import {BasicIconButton} from '@pb/kit-component-icon-button';
import {Cell, Row} from '@pb/kit-component-table';


import {next} from '../../entitlement-drawer.slice';
import {EntitlementType as EntitlementTypes} from '../../typedef';

import type {Grant} from 'src/openapi/admin/models/Grant';
import type {Pagination} from 'src/openapi/admin/models/Pagination';

type Props = {
    grant: Grant,
    pagination: Pagination,
    index: number,
    setGrantForDeletion: (grant: Grant) => void,
};

export const NotAssociatedGrantRow = ({grant, pagination, index, setGrantForDeletion}: Props) => {
    const dispatch = useDispatch();

    const openResource = useCallback(() => {
        dispatch(next({entitlementType: EntitlementTypes.GRANT, entitlementId: grant.id}));
    }, [dispatch, grant]);

    const removeGrant = useCallback(() => {
        setGrantForDeletion(grant);
    }, [setGrantForDeletion, grant]);

    const rowNumber = useMemo(() => (
        getPaginatedRowNumber({...pagination, index: index + 1})
    ), [pagination, index]);

    return (
        <Row>
            <Cell>{rowNumber}</Cell>
            <Cell>
                <a onClick={openResource}>
                    <EllipsisTextHint title={grant.name}>
                        {grant.name}
                    </EllipsisTextHint>
                </a>
            </Cell>
            <Cell>
                <BasicIconButton onClick={removeGrant} iconProps={{type: Icons.TRASH}}/>
            </Cell>
        </Row>
    );
};
